import $ from 'jquery'
import 'slick-carousel'
import MicroModal from 'micromodal'
import { modal_template } from './_modal-template'

/* Property Detail Page Carousel */
const ngg_slideshow = $('.ngg-slideshow')
const ngg_slideshow_modal = $('.ngg-slideshow-modal')

ngg_slideshow.parent().append(
	`<a href="" class="property-detail-page__gallery-thumbnails" id="expand_gallery_thumbnails_js">
		<i class="fas fa-th-large"></i>
		<span class="screen-reader-text">View Gallery Thumbnails</span>
	</a>
	<a href="" class="property-detail-page__expand-gallery" id="expand_gallery_js">
		<i class="fas fa-expand-arrows-alt"></i>
		<span class="screen-reader-text">Expand Gallery</span>
	</a>`
)

// Show thumbnail gallery.
$('#expand_gallery_thumbnails_js').on('click', function (event) {
	event.preventDefault()

	MicroModal.show('modal-thumbnail-gallery', {
		onShow: modal => {
			Array.from(modal.getElementsByTagName('img')).forEach(image_tag => {
				const image = image_tag.getAttribute('data-lazy')
				image_tag.setAttribute('src', image)
			})
		},
		onClose: (modal, element, event) => {
			if (event) {
				event.preventDefault()
				event.stopPropagation()
			}
		},
		disableScroll: true,
	})
})

// Expand slide gallery full width.
$('#expand_gallery_js').on('click', function (event) {
	event.preventDefault()

	$('#property_detail_page_js').toggleClass('property-detail-page--gallery')

	ngg_slideshow.slick('setPosition')
})

// Arrows for gallery.
const properties_carousel_arrow_button_prev = `<button type="button" class="slick-prev">
	<span class="icon"></span>
	<span class="screen-reader-text">Previous</span>
</button>`

const properties_carousel_arrow_button_next = `<button type="button" class="slick-next">
	<span class="icon"></span>
	<span class="screen-reader-text">Next</span>
</button>`

// Initialize gallery.
ngg_slideshow
	.slick({
		// adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 10000,
		dots: false,
		infinite: true,
		// lazyLoad: 'ondemand',
		nextArrow: properties_carousel_arrow_button_prev,
		prevArrow: properties_carousel_arrow_button_next,
		slidesToScroll: 1,
		slidesToShow: 1,
		speed: 500,
	})
	.fadeIn()

// Options: event, slick, direction
ngg_slideshow.on('init afterChange lazyLoaded setPosition', function (event, slick) {
	const next_slide = slick.$slides[slick.currentSlide + 1]
	const current_slide = slick.$slides[slick.currentSlide]

	// ****
	// Lazy load first slides image.
	// ****
	if (0 === slick.currentSlide) {
		const current_image = $(current_slide).find('.ngg-gallery-slideshow-image').data('lazy')

		if (current_image) {
			$(current_slide)
				.find('.ngg-gallery-slideshow-image')
				.css('background-image', `url('${current_image}')`)
				.removeAttr('data-lazy')
		}
	}

	// ****
	// Lazy load next slides image.
	// ****
	if (next_slide) {
		const next_slide_inner_html = $(next_slide.innerHTML)
		const next_image = $(next_slide_inner_html).find('.ngg-gallery-slideshow-image').data('lazy')

		if (next_image) {
			$(next_slide_inner_html)
				.find('.ngg-gallery-slideshow-image')
				.css('background-image', `url('${next_image}')`)
				.removeAttr('data-lazy')

			slick.$slides[slick.currentSlide + 1].innerHTML = $(next_slide_inner_html).html()
		}
	}

	// ****
	// Lazy load previous slides image.
	// ****
	if (0 === slick.currentSlide) {
		// If the first slide we need to get the last slide.
		const next_slide = slick.$slides[slick.$slides.length - 1]

		const next_slide_inner_html = $(next_slide.innerHTML)
		const next_image = $(next_slide_inner_html).find('.ngg-gallery-slideshow-image').data('lazy')

		if (next_image) {
			$(next_slide_inner_html)
				.find('.ngg-gallery-slideshow-image')
				.css('background-image', `url('${next_image}')`)
				.removeAttr('data-lazy')

			slick.$slides[slick.$slides.length - 1].innerHTML = $(next_slide_inner_html).html()
		}
	} else {
		// If we continue to move backwards we want to continue to lazy load the previous slide image.
		const next_slide = slick.$slides[slick.currentSlide - 1]

		const next_slide_inner_html = $(next_slide.innerHTML)
		const next_image = $(next_slide_inner_html).find('.ngg-gallery-slideshow-image').data('lazy')
		if (next_image) {
			$(next_slide_inner_html)
				.find('.ngg-gallery-slideshow-image')
				.css('background-image', `url('${next_image}')`)
				.removeAttr('data-lazy')

			slick.$slides[slick.currentSlide - 1].innerHTML = $(next_slide_inner_html).html()
		}
	}

	// ****
	// Animate background-image on mousemove.
	// ****
	// const current_slide_image = $(current_slide).find('.ngg-gallery-slideshow-image')

	// let img_width = 0
	// let img_height = 0
	// let mouse_horizontal = 0
	// let mouse_vertical = 0

	// current_slide_image.on('mousemove', function (event) {
	// 	img_width = $(this).width()
	// 	img_height = $(this).height()
	// 	mouse_horizontal = event.offsetX
	// 	mouse_vertical = event.offsetY
	// })

	// window.requestAnimationFrame(function moveBackground() {
	// 	current_slide_image.each(function () {
	// 		const background_position_horizontal = Math.round((mouse_horizontal / img_width) * 100)
	// 		const background_position_vertical = Math.round((mouse_vertical / img_height) * 100)

	// 		$(this).css('background-position', `${background_position_horizontal}% ${background_position_vertical}%`)
	// 	})
	// 	window.requestAnimationFrame(moveBackground)
	// })
})

// Inject thumbnail gallery.
ngg_slideshow.after(modal_template(ngg_slideshow_modal.html(), 'modal-thumbnail-gallery', 'modal--gallery'))

// ****
// Related Properties Carousel.
// ****
$('#related_properties_js')
	.removeClass('stick-height')
	.slick({
		adaptiveHeight: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 10000,
		dots: true,
		infinite: true,
		nextArrow: properties_carousel_arrow_button_prev,
		prevArrow: properties_carousel_arrow_button_next,
		slidesToShow: 3,
		speed: 500,
		responsive: [
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	})
	.fadeIn()
